import ProductGrid from '@/components/ProductGrid';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';
import { PaginationResult, ProductVariant, ShoppeProduct } from '@/types';

type Variant = Pick<ProductVariant, 'color' | 'images'>;
type Product = Omit<ShoppeProduct<Variant>, 'code' | 'details'>;

interface ShoppeSubCategory {
  name: string;
  group: {
    name: string;
  };
}

const ShowSubCategory = ({
  subCategory,
  result,
}: {
  subCategory: ShoppeSubCategory;
  result: PaginationResult<Product>;
}) => {
  return (
    <Band tone="surface">
      <SectionLayout width="wide" space="lg">
        <div className="flex flex-col gap-2">
          {/* Display1 renders the page's <h1>. */}
          <Typography.Display1 className="capitalize">
            {subCategory.group.name} {subCategory.name}
          </Typography.Display1>
          <Typography.Small>
            {result.total
              ? `Showing ${result.from}–${result.to} of ${result.total} products`
              : 'No products yet'}
          </Typography.Small>
        </div>

        <ProductGrid result={result} />
      </SectionLayout>
    </Band>
  );
};

export default ShowSubCategory;
